export default __webpack_public_path__ + "static/media/regulatory--all-directions-permitted--g1.e567ddaa.png";